﻿'use strict';

angular.module('ntmApp').factory('WeeklyHoursFilter', function () {

    function WeeklyHoursFilter(labelPattern) {
        var pattern = labelPattern;
        this.hours = 0.00;
        this.hoursComparator = '>=';
        this.selectedDays = [];

        this.daysOfWeek = [
          { label: 'Su', dayOfWeek: 0 },
          { label: 'M',  dayOfWeek: 1 },
          { label: 'Tu', dayOfWeek: 2 },
          { label: 'W',  dayOfWeek: 3 },
          { label: 'Th', dayOfWeek: 4 },
          { label: 'F',  dayOfWeek: 5 },
          { label: 'S', dayOfWeek: 6 }
        ];

        this.isDefined = function () {
            return this.hours &&
                   this.hoursComparator &&
                   this.selectedDays.length > 0;
        };

        this.isPartlyDefined = function () {
            return this.hours ||
                   this.hoursComparator !== '>=' ||
                   this.selectedDays.length > 0;
        };

        this.clear = function () {
            this.hours = 0.00;
            this.hoursComparator = '>=';
            this.selectedDays = [];
        };

        this.getLabel = function () {
            var hoursLabel = pattern.format(this.hoursComparator, this.hours);
            
            if (this.selectedDays.length > 0) {

                var daysLabels = this.selectedDays.sort(function (day1, day2) {
                    return day1.dayOfWeek - day2.dayOfWeek;
                }).map(function (day) {
                    return day.label;
                });

                return hoursLabel + ' on: ' + daysLabels.join(', ');
            }

            return hoursLabel;
        };
    }

    return (WeeklyHoursFilter);
});